/**
 * IMPORTS
 */

/**
 * Verifica se uma célula está vazia.
 *
 * @param valor - O valor da célula a ser verificada.
 * @returns true se a célula está vazia, false caso contrário.
 */
function handleIsCellEmpty(valor: unknown): boolean {
  // verificando se a célula está vazia
  if (valor === null || valor === undefined) return true;

  // verificando se o valor é um número
  if (typeof valor === "number") return false;

  // verificando se o valor é um boolean
  if (typeof valor === "boolean") return false;

  // verificando se o valor é uma string e está em branco
  return String(valor).trim() === "";
}

/**
 * EXPORTS
 */
export { handleIsCellEmpty };
